exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mui-errorView .text-icon__header{font-size:1rem;color:#343334}.mui-errorView .text-icon__body{font-size:.875rem}", ""]);

// exports
